import { makeStyles } from "@material-ui/core/styles";

export const companyIconStyles = makeStyles({
  root: {
    width: "50%",
    height: "50%"
  }
});
